module.exports = __webpack_public_path__ + "img/VsShimmer1.1f0e50d5.jpg";